import React, { createContext, useReducer } from "react";

import { DWPMetadataReducer } from "../reducers/DWPMetadataReducer";

export const DWPMetadataContext = createContext();

const DWPMetadataContextProvider = (props) => {
  const state = {
    pendingPlanFinalization: false,
  };
  const [viewModelDWP, dispatchDWP] = useReducer(DWPMetadataReducer, state);
  return (
    <DWPMetadataContext.Provider value={{ viewModelDWP, dispatchDWP }}>
      {props.children}
    </DWPMetadataContext.Provider>
  );
};

export default DWPMetadataContextProvider;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/context/DWPMetadataContext.js